import React, { useState } from 'react';
import { motion } from 'framer-motion';
import './MainContent.css';

const Roadmap = () => {
  const [expandedPhase, setExpandedPhase] = useState(null);
  
  // Roadmap data
  const roadmapData = [
    {
      phase: "Q1 2025",
      title: "Launch This Mf Scam",
      status: "completed",
      description: "Convince broke-ass degens to ape into our completely made-up tech with fancy buzzwords.",
      milestones: [
        "Copy/paste some Solana code & pretend we wrote it",
        "Pay Instagram influencers to shill tokens they don't understand",
        "Create 50 fake Twitter accounts to hype our 'revolutionary tech'",
        "Make up 'Proof-of-Wigga' protocol (it literally does nothing)",
        "List on sketchy exchanges that don't require KYC"
      ]
    },
    {
      phase: "Q2 2025",
      title: "Pump Before The Dump",
      status: "current",
      description: "Fake partnerships, staged AMAs, and promise features we have no intention of building.",
      milestones: [
        "Release 'WiggaSwap' (just a Uniswap fork with our logo slapped on it)",
        "Announce 'WiggaFinance' lending platform that's 87% likely to get hacked",
        "Fake screenshots of our 'cross-chain bridges' that don't exist",
        "Pay CoinTelegraph for a sponsored article calling us 'Ethereum Killer'",
        "Bribe crypto YouTubers to put our logo in their thumbnails"
      ]
    },
    {
      phase: "Q3 2025",
      title: "Blame Technical Difficulties",
      status: "upcoming",
      description: "Push deadlines, blame 'market conditions' and start preparing exit strategy.",
      milestones: [
        "Announce WiggaWallet delays due to 'security audits' (we ain't doing no audits)",
        "Claim our facial recognition is 'too advanced' for current tech (it's a Snapchat filter)",
        "Blame Apple/Google for app store rejection (we never submitted shit)",
        "Tweet fake partnership logos then delete when called out",
        "Announce '10x throughput' by changing one number in our whitepaper"
      ]
    },
    {
      phase: "Q4 2025",
      title: "Prepare The Exit Scam",
      status: "upcoming",
      description: "Liquidate team tokens while keeping community hyped on hopium.",
      milestones: [
        "Announce integration with every blockchain (we just add dropdown options)",
        "Launch global marketing campaign (three billboards in Miami during crypto week)",
        "Start selling team tokens through multiple wallets to avoid detection",
        "Create fake GitHub commits to look busy while doing nothing",
        "Announce AI predictive trading that's just random number generator with cool UI"
      ]
    },
    {
      phase: "Q1 2026",
      title: "Ghost The Community",
      status: "upcoming",
      description: "Disappear with millions while blaming 'market conditions' and 'regulatory uncertainty'.",
      milestones: [
        "Transfer remaining liquidity to 'cold storage' (founder's personal wallets)",
        "Delete Telegram group, claim 'hackers' took over our socials",
        "Post one last inspirational message about 'building through the bear market'",
        "Replace website with 'Under Maintenance' message",
        "Move to non-extradition country and start planning next scam called 'WiggaChain 2.0'"
      ]
    }
  ];
  
  // Toggle expanded phase
  const togglePhase = (index) => {
    if (expandedPhase === index) {
      setExpandedPhase(null);
    } else {
      setExpandedPhase(index);
    }
  };
  
  // Animation variants
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };
  
  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        duration: 0.5
      }
    }
  };
  
  return (
    <section id="roadmap" className="roadmap-section">
      <div className="section-container">
        <motion.div 
          className="section-header"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <h2 className="section-title">The <span className="gradient-text">Master Plan</span></h2>
          <div className="title-underline"></div>
          <p className="section-subtitle">
            Our totally legitimate roadmap that we definitely won't abandon as soon as we dump our tokens
          </p>
        </motion.div>
        
        <motion.div 
          className="roadmap-timeline"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          {roadmapData.map((phase, index) => (
            <motion.div 
              key={index} 
              className={`roadmap-phase ${phase.status} ${expandedPhase === index ? 'expanded' : ''}`}
              variants={itemVariants}
            >
              <div className="phase-marker">
                <div className="marker-line"></div>
                <div className="marker-circle"></div>
              </div>
              
              <div className="phase-content" onClick={() => togglePhase(index)}>
                <div className="phase-header">
                  <div className="phase-time">{phase.phase}</div>
                  <div className={`phase-status ${phase.status}`}>
                    {phase.status === 'completed' ? 'Somehow Worked' : 
                     phase.status === 'current' ? 'Scamming Now' : 'Future Rugpull'}
                  </div>
                </div>
                
                <h3 className="phase-title">{phase.title}</h3>
                <p className="phase-description">{phase.description}</p>
                
                <div className="phase-arrow">
                  <span>{expandedPhase === index ? '−' : '+'}</span>
                </div>
                
                {expandedPhase === index && (
                  <motion.div 
                    className="phase-milestones"
                    initial={{ opacity: 0, height: 0 }}
                    animate={{ opacity: 1, height: 'auto' }}
                    transition={{ duration: 0.3 }}
                  >
                    <h4 className="milestones-title">Based Strategy:</h4>
                    <ul className="milestones-list">
                      {phase.milestones.map((milestone, mIndex) => (
                        <li key={mIndex} className="milestone-item">
                          {milestone}
                        </li>
                      ))}
                    </ul>
                  </motion.div>
                )}
              </div>
            </motion.div>
          ))}
        </motion.div>
        
        <motion.div 
          className="roadmap-cta"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.8 }}
        >
          <h3 className="cta-title">Got more than two brain cells?</h3>
          <p className="cta-text">
            This is obviously a joke, but you'll still ape in because you're a degen with FOMO. We understand.
          </p>
          <button className="secondary-button">
            <span>Buy These Worthless Tokens</span>
          </button>
        </motion.div>
      </div>
      
      <div className="section-background">
        <div className="cyber-grid roadmap-grid"></div>
        <div className="glow-orb roadmap-orb-1"></div>
        <div className="glow-orb roadmap-orb-2"></div>
      </div>
    </section>
  );
};

export default Roadmap;